import { FieldMapper } from '@/modules/common/utils/entity-changes-manager';

import { Employee } from '../types/employees.types';

export interface EmployeeFieldValues {
  name: string;
  email?: string | null;
}

/**
 * Field mapper implementation for Employee entities
 */
export class EmployeeFieldMapper implements FieldMapper<Employee, EmployeeFieldValues> {
  getFieldValue(employee: Employee, field: keyof EmployeeFieldValues): string {
    switch (field) {
      case 'name':
        return employee.name;
      case 'email':
        return employee.email ?? '';
      default:
        throw new Error(`Unknown field: ${String(field)}`);
    }
  }

  getTrackableFields(employee: Employee): EmployeeFieldValues {
    return {
      name: employee.name,
      email: employee.email,
    };
  }
}
